@if (isActive) {
  <topo-modal
    id="recipient-list-select"
    [isActive]="isActive"
    [backgroundCanClose]="false"
    [rawWidth]="'90vw'"
    [rawHeight]="'80vh'"
    [isCard]="true"
    (close)="cancelClick()">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">
          {{
            (intitalSelectedTypeUId
              ? readonlyTemplateRecipients
                ? 'COMMUNICATIONS.TEMPLATE-RECIPIENTS'
                : 'COMMUNICATIONS.MANAGE-RECIPIENTS'
              : 'COMMUNICATIONS.ADD-RECIPIENTS'
            ) | translate
          }}
        </h5>
        <div class="select is-secondary is-medium type-selection">
          @if (canChangeType) {
            <select
              #recipientTypeSelect
              [ngModel]="selectedRecipentTypeUId"
              (change)="onRecipientTypeChanged($event, recipientTypeSelect.value)">
              @for (recipientType of recipientTypes; track recipientType?.uId) {
                <option
                  [value]="recipientType?.uId"
                  [class.option-separator]="recipientType?.uId === '0'"
                  [class.option-datasets]="recipientType?.uId === '1'"
                  [disabled]="recipientType?.uId === '0' || recipientType?.uId === '1'">
                  {{ recipientType?.name }}
                </option>
              }
            </select>
          }
        </div>
        <div
          class="dialog-close"
          (click)="cancelClick()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div style="position: relative">
        @if (selectedRecipentTypeUId === distRecipientTypeUId && hasDistTypes) {
          <div
            class="distribution-list-type"
            fxLayout="row"
            fxLayoutAlign="center center">
            <div class="type-header">{{ 'COMMUNICATIONS.COLUMNS.TYPE' | translate }}</div>
            <div class="select is-small is-fullwidth">
              <select
                [(ngModel)]="selectedDistributionListType"
                (change)="distributionListTypeChanged($event)">
                @for (type of distributionListTypes; track type.value) {
                  <option [ngValue]="type.value">
                    {{ type.name }}
                  </option>
                }
              </select>
            </div>
          </div>
        }
        <div
          class="recipient-select-page"
          [ngClass]="{ 'has-filter': isDatasetSelected && !readonlyTemplateRecipients }">
          <div class="data-table">
            <topo-data-table-server
              #table
              [isActive]="true"
              [datasource]="datasource"
              [columns]="columDefs"
              [showHeader]="false"
              [headerLabel]="headerLabel"
              [showRowGroups]="false"
              [embedded]="true"
              [rawHeight]="'calc(80vh - 356px)'"
              [rowHeight]="56"
              [getRowId]="getRowId"
              [autoFitColumns]="true"
              [headerIcon]="headerIcon"
              [showNewButton]="false"
              [showHeader]="true"
              [showSearch]="true"
              [showMenu]="false"
              [showRowGroups]="false"
              [showSystemFields]="true"
              [enableInfiniteScroll]="true"
              [enableServerSort]="false"
              (paginate)="onPaginate($event)"
              (takeChanged)="onTakeChanged($event)"
              (rowSelected)="onRowSelected($event)"
              (searchFilterChanged)="onSearchFilterChanged($event)"
              (storeUpdatedCalled)="onGridDataLoaded($event)"
              (rowsChanged)="onRowsChanged()"
              [skip]="skip"
              [take]="take"
              [totalCount]="totalCount"></topo-data-table-server>
          </div>
        </div>
        @if (!readonlyTemplateRecipients) {
          <div
            class="selected-section"
            fxLayout="row"
            fxLayoutAlign="center center">
            <div class="type-header">{{ 'COMMUNICATIONS.TOTAL-SELECTED' | translate: { number: selectedUIds?.length ?? 0 } }}</div>
          </div>
        }
        @if (isDatasetSelected && !readonlyTemplateRecipients) {
          <div class="recipient-filter">
            <div class="header">
              <div class="title">{{ 'COMMUNICATIONS.FILTERS' | translate }}</div>
            </div>
            <topo-table-filter
              [defaultView]="defaultTableView"
              [filters]="getDatasetTableFilter()"
              [dataset]="selectedRecipentType"
              (filterChanged)="documentFilterChanged($event)"></topo-table-filter>
          </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      @if (!readonlyTemplateRecipients) {
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          class="mt-4 mb-4">
          <div fxLayoutAlign="start">
            <div style="margin-right: 5px">
              <button
                class="button is-secondary"
                (click)="cancelClick()">
                {{ 'COMMUNICATIONS.BUTTONS.CANCEL' | translate }}
              </button>
            </div>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="8px">
            <button
              [disabled]="!canSave()"
              class="button is-secondary"
              (click)="saveClick(false)">
              {{ 'COMMUNICATIONS.BUTTONS.SAVE' | translate }}
            </button>
            <button
              [disabled]="!canSave()"
              class="button is-primary"
              (click)="saveClick(true)">
              {{ 'COMMUNICATIONS.BUTTONS.SAVE-CLOSE' | translate }}
            </button>
          </div>
        </div>
      }
      @if (readonlyTemplateRecipients) {
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          class="mt-4 mb-4">
          <div></div>
          <div fxLayoutAlign="start">
            <div style="margin-right: 5px">
              <button
                class="button is-secondary"
                (click)="cancelClick()">
                {{ 'COMMUNICATIONS.BUTTONS.CLOSE' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </topo-modal>
}

<topo-comms-recipient-details-list
  [activeContext]="detailsContext"
  (recipientsDetailsClosed)="onCloseRecipientDetails()"></topo-comms-recipient-details-list>
